// extracted by mini-css-extract-plugin
export var grid = "fp-lF";
export var gridWithRowGap = "fp-mF";
export var maxWidthContainer = "fp-qF";
export var mt0 = "fp-dF";
export var mt1 = "fp-eF";
export var mt2 = "fp-fF";
export var mt3 = "fp-gF";
export var mt4 = "fp-hF";
export var mt5 = "fp-iF";
export var mt6 = "fp-jF";
export var removeVisuallyHidden = "fp-oF";
export var tooltip = "fp-rF";
export var tooltip__content = "fp-tF";
export var tooltip__trigger = "fp-sF";
export var tooltip__triggerButton = "fp-kF";
export var visuallyHidden = "fp-nF";
export var widgetBase = "fp-pF";